import React from 'react';
import { Users, MapPin, Waves } from 'lucide-react';
import { useSiteData } from '../lib/SiteDataContext';
import { useLang } from '../lib/LanguageContext';
import { resolveImage } from '../lib/api';

const Stat = ({ icon: Icon, value, label }) => (
  <div className="flex items-start gap-4 rounded-lg border border-[#E6DDC8] bg-white p-5 shadow-sm">
    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-[#F6F2EA] text-[#C9A86A]">
      <Icon size={20} />
    </div>
    <div>
      <div className="font-serif text-2xl font-bold text-[#0B2545]">{value}</div>
      <div className="mt-0.5 text-[12.5px] uppercase tracking-wide text-[#0B2545]/60">{label}</div>
    </div>
  </div>
);

const StateProfile = () => {
  const { settings } = useSiteData();
  const { t } = useLang();
  const sp = settings?.state_profile;
  const hs = settings?.home_sections || {};
  if (!sp) return null;
  const mapImg = sp.map_image_url ? resolveImage(sp.map_image_url) : '';
  return (
    <section className="bg-gradient-to-b from-[#FAF6EC] to-[#F2EBD8] py-24">
      <div className="mx-auto max-w-[1280px] px-6">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <div className="relative">
              <div className="absolute -bottom-3 -right-3 h-24 w-24 border-b-2 border-r-2 border-[#C9A86A]" />
              <div className="overflow-hidden rounded-md bg-white shadow-xl">
                {mapImg ? (
                  <img src={mapImg} alt="State map" className="h-auto w-full object-contain" />
                ) : (
                  <div className="flex h-[360px] w-full items-center justify-center bg-[#F6F2EA] text-[#0B2545]/40">
                    <span className="text-[13px]">{t('Map not set')}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="lg:col-span-6">
            <div className="mb-3 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#C9A86A]">
              {hs.state_profile_eyebrow || t('State Profile')}
            </div>
            <h2 className="font-serif text-3xl font-bold leading-tight text-[#0B2545] md:text-[40px]">
              {hs.state_profile_title || t('Population')}
            </h2>
            <div className="mt-5 h-[3px] w-16 bg-[#C9A86A]" />
            <p className="mt-6 whitespace-pre-line text-[15px] leading-relaxed text-[#0B2545]/80">
              {sp.description}
            </p>
            <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-3">
              <Stat icon={Users} value={sp.population} label={t('Population')} />
              <Stat icon={MapPin} value={sp.regions} label={t('Regions')} />
              <Stat icon={Waves} value={sp.coastline} label={t('Coastline')} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StateProfile;
